import { useParams, Link } from 'react-router-dom';
import PageMeta from '@/components/base/PageMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import DramaCard from '@/components/base/DramaCard';
import { categories, getDramasByCategory } from '@/mocks/dramas';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';
  const currentCategory = categories.find((c) => c.slug === currentSlug) || categories[0];
  const filteredDramas = getDramasByCategory(currentSlug);

  const categoryTitle = currentSlug === 'all' ? '全部剧集' : currentCategory.name;
  const categoryDesc = currentSlug === 'all'
    ? '天天影院全部电视剧资源，国产剧、韩剧、美剧、日剧一网打尽'
    : `天天影院${currentCategory.name}资源，海量${currentCategory.name}全集免费在线观看`;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://tiantiancinema.com/' },
      { '@type': 'ListItem', position: 2, name: categoryTitle, item: `https://tiantiancinema.com/category/${currentSlug}` },
    ],
  };

  return (
    <>
      <PageMeta
        title={`${categoryTitle} - 天天影院 | 最新电视剧全集在线观看`}
        description={categoryDesc}
        keywords={`天天影院,${categoryTitle},${currentCategory.name}全集,在线观看,免费追剧`}
        canonicalUrl={`https://tiantiancinema.com/category/${currentSlug}`}
        ogTitle={`${categoryTitle} - 天天影院`}
        ogDescription={categoryDesc}
        ogUrl={`https://tiantiancinema.com/category/${currentSlug}`}
        schemaObjects={[breadcrumbSchema]}
      />

      <div className="w-full px-4 md:px-6 pt-24 pb-14">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: categoryTitle },
            ]}
          />

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              {categoryTitle}
            </h1>
            <p className="text-sm text-foreground-500">
              共找到 {filteredDramas.length} 部剧集
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  currentSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredDramas.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
              {filteredDramas.map((drama) => (
                <DramaCard key={drama.id} drama={drama} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                <i className="ri-emotion-sad-line text-foreground-400 text-2xl"></i>
              </div>
              <p className="text-foreground-500 text-sm">暂无该分类的剧集</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}